import type { InvoiceStatus } from '@otter/shared';

const MAP: Record<InvoiceStatus, { className: string; label: string }> = {
  borrador: { className: 'pill draft', label: 'BORRADOR' },
  emitida: { className: 'pill info', label: 'EMITIDA' },
  enviada: { className: 'pill sent', label: 'ENVIADA' },
  cobrada: { className: 'pill ok', label: 'COBRADA' },
  vencida: { className: 'pill warn', label: 'VENCIDA' },
};

export function InvoicePill({ status }: { status: InvoiceStatus }) {
  const def = MAP[status];
  return <span className={def.className}>{def.label}</span>;
}

const CLIENT_MAP: Record<string, { className: string; label: string }> = {
  activo: { className: 'pill ok', label: 'ACTIVO' },
  mora: { className: 'pill warn', label: 'MORA' },
  inactivo: { className: 'pill draft', label: 'INACTIVO' },
};

export function ClientPill({ status }: { status: string }) {
  const def = CLIENT_MAP[status] ?? CLIENT_MAP.inactivo!;
  return <span className={def.className}>{def.label}</span>;
}
